/**
 * DevExtreme (esm/__internal/scheduler/utils/options/constants.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import messageLocalization from "../../../../common/core/localization/message";
import devices from "../../../../core/devices";
import $ from "../../../../core/renderer";
import dateUtils from "../../../../core/utils/date";
import { isMaterial, isMaterialBased } from "../../../../ui/themes";
const DEFAULT_APPOINTMENT_TEMPLATE_NAME = "item";
const DEFAULT_APPOINTMENT_COLLECTOR_TEMPLATE_NAME = "appointmentCollector";
const DEFAULT_DROP_DOWN_APPOINTMENT_TEMPLATE_NAME = "dropDownAppointment";
export const DEFAULT_SCHEDULER_INTERNAL_OPTIONS = {
  indicatorTime: void 0,
  renovateRender: true,
  _draggingMode: "outlook",
  _appointmentTooltipOffset: {
    x: 0,
    y: 0
  },
  _appointmentCountPerCell: 2,
  _collectorOffset: 0,
  _appointmentOffset: 26,
  appointmentPopupTemplate: "appointmentPopup",
  disabledExpr: "disabled",
  allowMultipleCellSelection: true
};
export const DEFAULT_SCHEDULER_OPTIONS = {
  views: ["day", "week"],
  currentView: "day",
  currentDate: dateUtils.trimTime(new Date()),
  min: void 0,
  max: void 0,
  dateSerializationFormat: void 0,
  firstDayOfWeek: void 0,
  groups: [],
  resources: [],
  dataSource: null,
  customizeDateNavigatorText: void 0,
  appointmentTemplate: "item",
  dropDownAppointmentTemplate: "dropDownAppointment",
  appointmentCollectorTemplate: "appointmentCollector",
  dataCellTemplate: void 0,
  timeCellTemplate: void 0,
  resourceCellTemplate: void 0,
  dateCellTemplate: void 0,
  startDayHour: 0,
  endDayHour: 24,
  offset: 0,
  editing: {
    allowAdding: true,
    allowDeleting: true,
    allowDragging: true,
    allowResizing: true,
    allowUpdating: true,
    allowTimeZoneEditing: false
  },
  showAllDayPanel: true,
  showCurrentTimeIndicator: true,
  shadeUntilCurrentTime: false,
  indicatorUpdateInterval: 3e5,
  recurrenceEditMode: "dialog",
  cellDuration: 30,
  maxAppointmentsPerCell: "auto",
  selectedCellData: [],
  groupByDate: false,
  onAppointmentRendered: void 0,
  onAppointmentClick: void 0,
  onAppointmentDblClick: void 0,
  onAppointmentContextMenu: void 0,
  onCellClick: void 0,
  onCellContextMenu: void 0,
  onAppointmentAdding: void 0,
  onAppointmentAdded: void 0,
  onAppointmentUpdating: void 0,
  onAppointmentUpdated: void 0,
  onAppointmentDeleting: void 0,
  onAppointmentDeleted: void 0,
  onAppointmentFormOpening: void 0,
  onAppointmentTooltipShowing: void 0,
  appointmentTooltipTemplate: "appointmentTooltip",
  crossScrollingEnabled: false,
  useDropDownViewSwitcher: false,
  startDateExpr: "startDate",
  endDateExpr: "endDate",
  textExpr: "text",
  descriptionExpr: "description",
  allDayExpr: "allDay",
  recurrenceRuleExpr: "recurrenceRule",
  recurrenceExceptionExpr: "recurrenceException",
  remoteFiltering: false,
  timeZone: "",
  startDateTimeZoneExpr: "startDateTimeZone",
  endDateTimeZoneExpr: "endDateTimeZone",
  noDataText: messageLocalization.format("dxCollectionWidget-noDataText"),
  adaptivityEnabled: false,
  scrolling: {
    mode: "standard"
  },
  allDayPanelMode: "all",
  toolbar: {
    disabled: false,
    multiline: false,
    items: [{
      location: "before",
      name: "dateNavigator"
    }, {
      location: "after",
      name: "viewSwitcher"
    }]
  }
};
export const DEFAULT_SCHEDULER_INTEGRATION_OPTIONS = {
  integrationOptions: {
    useDeferUpdateForTemplates: false
  }
};
export const DEPRECATED_SCHEDULER_OPTIONS = {
  dropDownAppointmentTemplate: {
    since: "19.2",
    message: "appointmentTooltipTemplate"
  }
};
export const DEFAULT_SCHEDULER_OPTIONS_RULES = [{
  device: () => "desktop" === devices.real().deviceType && !devices.isSimulator(),
  options: {
    focusStateEnabled: true
  }
}, {
  device: () => !devices.current().generic,
  options: {
    useDropDownViewSwitcher: true,
    editing: {
      allowDragging: false,
      allowResizing: false
    }
  }
}, {
  device: () => isMaterialBased(),
  options: {
    useDropDownViewSwitcher: true,
    dateCellTemplate: (data, _, element) => {
      const {
        text = ""
      } = data;
      text.split(" ").forEach((word, wordIndex) => {
        const span = $("<span>").text(word).addClass("dx-scheduler-header-panel-cell-date");
        $(element).append(span);
        if (!wordIndex) {
          $(element).append(" ");
        }
      });
    },
    _appointmentCountPerCell: 1,
    _collectorOffset: 20,
    _appointmentOffset: 30
  }
}, {
  device: () => isMaterial(),
  options: {
    _appointmentTooltipOffset: {
      x: 0,
      y: 11
    }
  }
}];